export var NOT_INITED = 1;
export var INITED = 2;
export var UPDATING = 3;



// WEBPACK FOOTER //
// ./src/constants/RepositoryState.js